import * as actionTypes from "../../Actions";

const initialState = {
    minimumRates: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_MINIMUM_RATES:
            return {
                ...state,
                minimumRates: action.payload
            }
        default:
            return state;
    }
}

export default reducer;
